import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NumberToPersianWord from "number_to_persian_word";
import { useLocation } from "react-router-dom";

function GetMeasurementArrayPanel({ modelId, cartValues }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [measurements, setMeasurements] = useState(undefined);

  // پنل مسیرهایی مثل /admin/panel2/fa/... دارد؛ زبان را از مسیر/i18n می‌گیریم
  const pageLanguage =
    location.pathname.includes("/fa") || i18n.language?.startsWith("fa") ? "fa" : "en";
  const t = i18n.getFixedT(pageLanguage);

  useEffect(() => {
    const NumToFa = (inputText) => {
      return pageLanguage === "fa" ? NumberToPersianWord.convertEnToPe(inputText) : inputText;
    };
    if (
      modelId === "0303" ||
      modelId === "0324" ||
      modelId === "0325" ||
      modelId === "0327" ||
      modelId === "0328" ||
      modelId === "0097"
    ) {
      if (cartValues["calcMeasurements"]) {
        if (cartValues["Mount"] === "Inside") {
          setMeasurements(
            <li className="cart_agree_item cart_agree_measurement 1">
              <span className="cart_agree_measurement_row">
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width 1")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["Width1"] ? cartValues["Width1"] : cartValues["Width"])}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width 2")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Width2"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width 3")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Width3"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                    :
                  </h1>
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                  </h2>
                </div>
              </span>
              <span className="cart_agree_measurement_row">
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["Height1"] ? cartValues["Height1"] : cartValues["Height"])}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Height2"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Height3"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                    :
                  </h1>
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                  </h2>
                </div>
              </span>
              <span className="cart_agree_measurement_row_bottom">
                <p
                  className="cart_agree_measurement_row_bottom_right 1"
                  style={{ textTransform: "none" }}
                >
                  {modelId === "0303"
                    ? t("Zebra Measurements text")
                    : modelId === "0324"
                    ? t("roller Measurements text")
                    : t("dualroller Measurements text")}
                </p>
              </span>
            </li>
          );
        } else if (cartValues["Mount"] === "Outside") {
          if (cartValues?.IsWalled === "Ceiling") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 2">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3A"] ? cartValues["Width3A"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row_bottom">
                  <ul
                    className="disc cart_agree_measurement_row_bottom_right 3"
                    style={{ textTransform: "none" }}
                  >
                    <li style={{ color: "#767676" }}>
                      {modelId === "0303"
                        ? t("Zebra Measurements text")
                        : modelId === "0324"
                        ? t("roller Measurements text")
                        : t("dualroller Measurements text")}
                    </li>
                    {cartValues["Mount"] &&
                      cartValues["Mount"] !== "Inside" &&
                      cartValues["SewingModelId"] !== "0097" && (
                        <li style={{ marginTop: "5px", color: "#767676" }}>
                          {t("dualroller Measurements")}
                        </li>
                      )}
                  </ul>
                </span>
              </li>
            );
          } else {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 3">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3A"] ? cartValues["Width3A"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["Height3C"] ? cartValues["Height3C"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row_bottom">
                  <ul
                    className="disc cart_agree_measurement_row_bottom_right 2"
                    style={{ textTransform: "none" }}
                  >
                    <li style={{ color: "#767676" }}>
                      {modelId === "0303"
                        ? t("Zebra Measurements text")
                        : modelId === "0324"
                        ? t("roller Measurements text")
                        : t("dualroller Measurements text")}
                    </li>
                    {cartValues["Mount"] &&
                      cartValues["Mount"] !== "Inside" &&
                      cartValues["SewingModelId"] !== "0097" && (
                        <li style={{ marginTop: "5px", color: "#767676" }}>
                          {t("dualroller Measurements")}
                        </li>
                      )}
                  </ul>
                </span>
              </li>
            );
          }
        } else {
          setMeasurements(
            <li className="cart_agree_item cart_agree_measurement 4">
              <span className="cart_agree_measurement_row">
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["Width3A"] ? cartValues["Width3A"] : cartValues["Width"])}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionRight"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                    :
                  </h1>
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                  </h2>
                </div>
              </span>
              <span className="cart_agree_measurement_row">
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(
                      cartValues["CeilingToWindow1"]
                        ? cartValues["CeilingToWindow1"]
                        : cartValues["Height"]
                    )}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(
                      cartValues["CeilingToWindow2"]
                        ? cartValues["CeilingToWindow2"]
                        : cartValues["Height2"]
                    )}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(
                      cartValues["CeilingToWindow3"]
                        ? cartValues["CeilingToWindow3"]
                        : cartValues["Height3"]
                    )}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                    :
                  </h1>
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                  </h2>
                </div>
              </span>
              <span className="cart_agree_measurement_row_bottom">
                <ul
                  className="disc cart_agree_measurement_row_bottom_right 3"
                  style={{ textTransform: "none" }}
                >
                  <li style={{ color: "#767676" }}>
                    {modelId === "0303"
                      ? t("Zebra Measurements text")
                      : modelId === "0324"
                      ? t("roller Measurements text")
                      : t("dualroller Measurements text")}
                  </li>
                  {cartValues["Mount"] &&
                    cartValues["Mount"] !== "Inside" &&
                    cartValues["SewingModelId"] !== "0097" && (
                      <li style={{ marginTop: "5px", color: "#767676" }}>
                        {t("dualroller Measurements")}
                      </li>
                    )}
                </ul>
              </span>
            </li>
          );
        }
      } else {
        setMeasurements(
          <li className="cart_agree_item cart_agree_measurement 5">
            <span className="cart_agree_measurement_row cart_agree_measurement_row_single">
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Width")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                </h2>
              </div>
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Height")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                </h2>
              </div>
            </span>
            <span className="cart_agree_measurement_row_bottom">
              <p
                className="cart_agree_measurement_row_bottom_right 4"
                style={{ textTransform: "none" }}
              >
                {modelId === "0303"
                  ? t("Zebra Measurements text")
                  : modelId === "0324"
                  ? t("roller Measurements text")
                  : t("dualroller Measurements text")}
              </p>
            </span>
          </li>
        );
      }
    } else if (modelId === "0326") {
      if (cartValues["calcMeasurements"]) {
        if (cartValues["Mount"] === "Inside") {
          setMeasurements(
            <li className="cart_agree_item cart_agree_measurement 6">
              <span className="cart_agree_measurement_row">
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width 1")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["Width1"] ? cartValues["Width1"] : cartValues["Width"])}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width 2")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Width2"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width 3")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Width3"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                    :
                  </h1>
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Width")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                  </h2>
                </div>
              </span>
              <span className="cart_agree_measurement_row">
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["Height1"] ? cartValues["Height1"] : cartValues["Height"])}
                  </h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Height2"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                  <h2 className="cart_agree_item_desc">{NumToFa(cartValues["Height3"])}</h2>
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                    :
                  </h1>
                  <h2 className="cart_agree_item_desc" />
                </div>
                <div className="cart_agree_measurement_row_section">
                  <h1 className="cart_agree_item_title">{t("Height")}</h1>
                  <h2 className="cart_agree_item_desc">
                    {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                  </h2>
                </div>
              </span>
              <span className="cart_agree_measurement_row_bottom">
                <p className="cart_agree_measurement_row_bottom_left">
                  {t("Curtain Dimension= ")}
                  {NumToFa(
                    cartValues["WidthCart"] +
                      t("Zebra Measurements W") +
                      " \u00d7 " +
                      cartValues["HeightCart"] +
                      t("Zebra Measurements H") +
                      t("Zebra Measurements cm")
                  )}
                </p>
              </span>
            </li>
          );
        } else if (cartValues["Mount"] === "HiddenMoulding") {
          if (cartValues["FinishedLengthType"] === "Sill") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 7">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row_bottom">
                  <p className="cart_agree_measurement_row_bottom_left">
                    {t("Curtain Dimension= ")}
                    {NumToFa(
                      cartValues["WidthCart"] +
                        t("Zebra Measurements W") +
                        " \u00d7 " +
                        cartValues["HeightCart"] +
                        t("Zebra Measurements H") +
                        t("Zebra Measurements cm")
                    )}
                  </p>
                  <p className="cart_agree_measurement_row_bottom_right 5">{t("dk sill text")}</p>
                </span>
              </li>
            );
          } else if (cartValues["FinishedLengthType"] === "Apron") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 8">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row_bottom">
                  <p className="cart_agree_measurement_row_bottom_left">
                    {t("Curtain Dimension= ")}
                    {NumToFa(
                      cartValues["WidthCart"] +
                        t("Zebra Measurements W") +
                        " \u00d7 " +
                        cartValues["HeightCart"] +
                        t("Zebra Measurements H") +
                        t("Zebra Measurements cm")
                    )}
                  </p>
                  <p className="cart_agree_measurement_row_bottom_right 6">{t("dk apron text")}</p>
                </span>
              </li>
            );
          } else {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 9">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor1"]
                          ? cartValues["CeilingToFloor1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor2"]
                          ? cartValues["CeilingToFloor2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor3"]
                          ? cartValues["CeilingToFloor3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row_bottom">
                  <p className="cart_agree_measurement_row_bottom_left">
                    {t("Curtain Dimension= ")}
                    {NumToFa(
                      cartValues["WidthCart"] +
                        t("Zebra Measurements W") +
                        " \u00d7 " +
                        cartValues["HeightCart"] +
                        t("Zebra Measurements H") +
                        t("Zebra Measurements cm")
                    )}
                  </p>
                  <p className="cart_agree_measurement_row_bottom_right 7">{t("dk floor text")}</p>
                </span>
              </li>
            );
          }
        } else {
          if (cartValues["IsWalled"] === "Ceiling") {
            if (cartValues["FinishedLengthType"] === "Sill") {
              setMeasurements(
                <li className="cart_agree_item cart_agree_measurement 10">
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionLeft"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionRight"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToWindow1"]
                            ? cartValues["CeilingToWindow1"]
                            : cartValues["Height"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToWindow2"]
                            ? cartValues["CeilingToWindow2"]
                            : cartValues["Height2"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToWindow3"]
                            ? cartValues["CeilingToWindow3"]
                            : cartValues["Height3"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row_bottom">
                    <p className="cart_agree_measurement_row_bottom_left">
                      {t("Curtain Dimension= ")}
                      {NumToFa(
                        cartValues["WidthCart"] +
                          t("Zebra Measurements W") +
                          " \u00d7 " +
                          cartValues["HeightCart"] +
                          t("Zebra Measurements H") +
                          t("Zebra Measurements cm")
                      )}
                    </p>
                    <p className="cart_agree_measurement_row_bottom_right 8">{t("dk sill text")}</p>
                  </span>
                </li>
              );
            } else if (cartValues["FinishedLengthType"] === "Apron") {
              setMeasurements(
                <li className="cart_agree_item cart_agree_measurement 11">
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionLeft"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionRight"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToWindow1"]
                            ? cartValues["CeilingToWindow1"]
                            : cartValues["Height"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToWindow2"]
                            ? cartValues["CeilingToWindow2"]
                            : cartValues["Height2"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToWindow3"]
                            ? cartValues["CeilingToWindow3"]
                            : cartValues["Height3"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row_bottom">
                    <p className="cart_agree_measurement_row_bottom_left">
                      {t("Curtain Dimension= ")}
                      {NumToFa(
                        cartValues["WidthCart"] +
                          t("Zebra Measurements W") +
                          " \u00d7 " +
                          cartValues["HeightCart"] +
                          t("Zebra Measurements H") +
                          t("Zebra Measurements cm")
                      )}
                    </p>
                    <p className="cart_agree_measurement_row_bottom_right 9">
                      {t("dk apron text")}
                    </p>
                  </span>
                </li>
              );
            } else {
              setMeasurements(
                <li className="cart_agree_item cart_agree_measurement 12">
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionLeft"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionRight"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToFloor1"]
                            ? cartValues["CeilingToFloor1"]
                            : cartValues["Height"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToFloor2"]
                            ? cartValues["CeilingToFloor2"]
                            : cartValues["Height2"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["CeilingToFloor3"]
                            ? cartValues["CeilingToFloor3"]
                            : cartValues["Height3"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row_bottom">
                    <p className="cart_agree_measurement_row_bottom_left">
                      {t("Curtain Dimension= ")}
                      {NumToFa(
                        cartValues["WidthCart"] +
                          t("Zebra Measurements W") +
                          " \u00d7 " +
                          cartValues["HeightCart"] +
                          t("Zebra Measurements H") +
                          t("Zebra Measurements cm")
                      )}
                    </p>
                    <p className="cart_agree_measurement_row_bottom_right 10">
                      {t("dk floor text")}
                    </p>
                  </span>
                </li>
              );
            }
          } else {
            if (cartValues["FinishedLengthType"] === "Sill") {
              setMeasurements(
                <li className="cart_agree_item cart_agree_measurement 13">
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionLeft"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionRight"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Height2D"] ? cartValues["Height2D"] : cartValues["Height"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                      <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row_bottom">
                    <p className="cart_agree_measurement_row_bottom_left">
                      {t("Curtain Dimension= ")}
                      {NumToFa(
                        cartValues["WidthCart"] +
                          t("Zebra Measurements W") +
                          " \u00d7 " +
                          cartValues["HeightCart"] +
                          t("Zebra Measurements H") +
                          t("Zebra Measurements cm")
                      )}
                    </p>
                    <p className="cart_agree_measurement_row_bottom_right 11">
                      {t("dk sill text")}
                    </p>
                  </span>
                </li>
              );
            } else if (cartValues["FinishedLengthType"] === "Apron") {
              setMeasurements(
                <li className="cart_agree_item cart_agree_measurement 14">
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionLeft"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionRight"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Height2D"] ? cartValues["Height2D"] : cartValues["Height"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                      <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row_bottom">
                    <p className="cart_agree_measurement_row_bottom_left">
                      {t("Curtain Dimension= ")}
                      {NumToFa(
                        cartValues["WidthCart"] +
                          t("Zebra Measurements W") +
                          " \u00d7 " +
                          cartValues["HeightCart"] +
                          t("Zebra Measurements H") +
                          t("Zebra Measurements cm")
                      )}
                    </p>
                    <p className="cart_agree_measurement_row_bottom_right 12">
                      {t("dk apron text")}
                    </p>
                  </span>
                </li>
              );
            } else {
              setMeasurements(
                <li className="cart_agree_item cart_agree_measurement 15">
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["Width2B"] ? cartValues["Width2B"] : cartValues["Width"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(L)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionLeft"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Extension(R)")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["ExtensionRight"])}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row">
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(
                          cartValues["WindowToFloor"]
                            ? cartValues["WindowToFloor"]
                            : cartValues["Height"]
                        )}
                      </h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                      <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                        :
                      </h1>
                      <h2 className="cart_agree_item_desc" />
                    </div>
                    <div className="cart_agree_measurement_row_section">
                      <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                      <h2 className="cart_agree_item_desc">
                        {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                      </h2>
                    </div>
                  </span>
                  <span className="cart_agree_measurement_row_bottom">
                    <p className="cart_agree_measurement_row_bottom_left">
                      {t("Curtain Dimension= ")}
                      {NumToFa(
                        cartValues["WidthCart"] +
                          t("Zebra Measurements W") +
                          " \u00d7 " +
                          cartValues["HeightCart"] +
                          t("Zebra Measurements H") +
                          t("Zebra Measurements cm")
                      )}
                    </p>
                    <p className="cart_agree_measurement_row_bottom_right 13">
                      {t("dk floor text")}
                    </p>
                  </span>
                </li>
              );
            }
          }
        }
      } else {
        setMeasurements(
          <li className="cart_agree_item cart_agree_measurement 16">
            <span className="cart_agree_measurement_row cart_agree_measurement_row_single">
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Width")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                </h2>
              </div>
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Height")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                </h2>
              </div>
            </span>
            <span className="cart_agree_measurement_row_bottom">
              <p className="cart_agree_measurement_row_bottom_left">
                {t("Curtain Dimension= ")}
                {NumToFa(
                  cartValues["WidthCart"] +
                    t("Zebra Measurements W") +
                    " \u00d7 " +
                    cartValues["HeightCart"] +
                    t("Zebra Measurements H") +
                    t("dk Measurements cm")
                )}
              </p>
            </span>
          </li>
        );
      }
    }
    if (modelId === "0099") {
      if (cartValues["calcMeasurements"]) {
        if (cartValues["hasRod"]) {
          if (cartValues["FinishedLengthType"] === "Sill") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 17">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true" ? t("Rod Length") : t("Track Length")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodWidth"] ? cartValues["RodWidth"] : cartValues["Width"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true"
                        ? t("Rod To Sill Height")
                        : t("Track To Sill Height")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodToBottom"] ? cartValues["RodToBottom"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (cartValues["FinishedLengthType"] === "Apron") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 18">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true" ? t("Rod Length") : t("Track Length")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodWidth"] ? cartValues["RodWidth"] : cartValues["Width"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true"
                        ? t("Rod To Sill Height")
                        : t("Track To Sill Height")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodToBottom"] ? cartValues["RodToBottom"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 19">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {(cartValues["step31"] === "true" || cartValues["hasRod"] === true) ? t("Rod Length") : t("Track Length")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodWidth"] ? cartValues["RodWidth"] : cartValues["Width"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {(cartValues["step31"] === "true" || cartValues["hasRod"] === true)
                        ? t("Rod To Floor Height")
                        : t("Track To Floor Height")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodToFloor"] ? cartValues["RodToFloor"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          }
        } else {
          let scenario = 0;
          if (
            cartValues["FinishedLengthType"] === "Sill" ||
            cartValues["FinishedLengthType"] === "Apron"
          ) {
            if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              (cartValues["CurtainPosition"] === "Standard" ||
                cartValues["CurtainPosition"] === "Left Corner Window" ||
                cartValues["CurtainPosition"] === "Right Corner Window")
            ) {
              scenario = 1;
            } else if (
              cartValues["Mount"] === "Wall" &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 2;
            } else if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 3;
            } else {
              scenario = 4;
            }
          } else {
            if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              (cartValues["CurtainPosition"] === "Standard" ||
                cartValues["CurtainPosition"] === "Left Corner Window" ||
                cartValues["CurtainPosition"] === "Right Corner Window")
            ) {
              scenario = 5;
            } else if (
              cartValues["Mount"] === "Wall" &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 6;
            } else if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 7;
            } else {
              scenario = 8;
            }
          }
          console.log(`scenario`, scenario);
          if (scenario === 1) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 20">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 2) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 21">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["Height3E"] ? cartValues["Height3E"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 3) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 22">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 4) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 23">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["Height3E"] ? cartValues["Height3E"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 5) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 24">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor1"]
                          ? cartValues["CeilingToFloor1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor2"]
                          ? cartValues["CeilingToFloor2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor3"]
                          ? cartValues["CeilingToFloor3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 6) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 25">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["WindowToFloor"]
                          ? cartValues["WindowToFloor"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 7) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 26">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor1"]
                          ? cartValues["CeilingToFloor1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor2"]
                          ? cartValues["CeilingToFloor2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor3"]
                          ? cartValues["CeilingToFloor3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 27">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window To Floor Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["WindowToFloor"]
                          ? cartValues["WindowToFloor"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount Height")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          }
        }
      } else {
        setMeasurements(
          <li className="cart_agree_item cart_agree_measurement 28">
            <span className="cart_agree_measurement_row cart_agree_measurement_row_single">
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Width")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                </h2>
              </div>
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Height")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                </h2>
              </div>
            </span>
          </li>
        );
      }
    }
    if (modelId === "0321") {
      if (cartValues["calcMeasurements"]) {
        if (cartValues["hasRod"]) {
          if (cartValues["FinishedLengthType"] === "Sill") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 29">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true" ? t("Rod Length") : t("Track Length")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodWidth"] ? cartValues["RodWidth"] : cartValues["Width"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true"
                        ? t("Rod To Sill Height")
                        : t("Track To Sill Height")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodToBottom"] ? cartValues["RodToBottom"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (cartValues["FinishedLengthType"] === "Apron") {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 30">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true" ? t("Rod Length") : t("Track Length")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodWidth"] ? cartValues["RodWidth"] : cartValues["Width"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true"
                        ? t("Rod To Sill Height")
                        : t("Track To Sill Height")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodToBottom"] ? cartValues["RodToBottom"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 31">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true" ? t("Rod Length") : t("Track Length")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodWidth"] ? cartValues["RodWidth"] : cartValues["Width"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">
                      {cartValues["step31"] === "true"
                        ? t("Rod To Floor Height")
                        : t("Track To Floor Height")}
                    </h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["RodToFloor"] ? cartValues["RodToFloor"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          }
        } else {
          let scenario = 0;
          if (
            cartValues["FinishedLengthType"] === "Sill" ||
            cartValues["FinishedLengthType"] === "Apron"
          ) {
            if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              (cartValues["CurtainPosition"] === "Standard" ||
                cartValues["CurtainPosition"] === "Left Corner Window" ||
                cartValues["CurtainPosition"] === "Right Corner Window")
            ) {
              scenario = 1;
            } else if (
              cartValues["Mount"] === "Wall" &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 2;
            } else if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 3;
            } else {
              scenario = 4;
            }
          } else {
            if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              (cartValues["CurtainPosition"] === "Standard" ||
                cartValues["CurtainPosition"] === "Left Corner Window" ||
                cartValues["CurtainPosition"] === "Right Corner Window")
            ) {
              scenario = 5;
            } else if (
              cartValues["Mount"] === "Wall" &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 6;
            } else if (
              (cartValues["Mount"] === "Ceiling" || cartValues["Mount"] === "Moulding") &&
              cartValues["CurtainPosition"] === "Wall to Wall"
            ) {
              scenario = 7;
            } else {
              scenario = 8;
            }
          }
          if (scenario === 1) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 32">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 2) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 33">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["Height3E"] ? cartValues["Height3E"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 3) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 34">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow1"]
                          ? cartValues["CeilingToWindow1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow2"]
                          ? cartValues["CeilingToWindow2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToWindow3"]
                          ? cartValues["CeilingToWindow3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 4) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 35">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["Height3E"] ? cartValues["Height3E"] : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 5) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 36">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor1"]
                          ? cartValues["CeilingToFloor1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor2"]
                          ? cartValues["CeilingToFloor2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor3"]
                          ? cartValues["CeilingToFloor3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 6) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 37">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["WindowToFloor"]
                          ? cartValues["WindowToFloor"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else if (scenario === 7) {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 38">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height A")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor1"]
                          ? cartValues["CeilingToFloor1"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height B")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor2"]
                          ? cartValues["CeilingToFloor2"]
                          : cartValues["Height2"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Height C")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["CeilingToFloor3"]
                          ? cartValues["CeilingToFloor3"]
                          : cartValues["Height3"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mounting Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          } else {
            setMeasurements(
              <li className="cart_agree_item cart_agree_measurement 39">
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Window Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["Width3C"] ? cartValues["Width3C"] : cartValues["Width"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(L)")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ExtensionLeft"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Stack Width(R)")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["ExtensionRight"])}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Width")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
                <span className="cart_agree_measurement_row">
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Width To Floor Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(
                        cartValues["WindowToFloor"]
                          ? cartValues["WindowToFloor"]
                          : cartValues["Height"]
                      )}
                    </h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator" />
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Mount Height")}</h1>
                    <h2 className="cart_agree_item_desc">{NumToFa(cartValues["ShadeMount"])}</h2>
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title cart_agree_measurement_row_operator cart_agree_measurement_row_operator_point">
                      :
                    </h1>
                    <h2 className="cart_agree_item_desc" />
                  </div>
                  <div className="cart_agree_measurement_row_section">
                    <h1 className="cart_agree_item_title">{t("Total Height")}</h1>
                    <h2 className="cart_agree_item_desc">
                      {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                    </h2>
                  </div>
                </span>
              </li>
            );
          }
        }
      } else {
        setMeasurements(
          <li className="cart_agree_item cart_agree_measurement 40">
            <span className="cart_agree_measurement_row cart_agree_measurement_row_single">
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Width")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowWidth"] + t("Measurements CM"))}
                </h2>
              </div>
              <div className="cart_agree_measurement_row_section">
                <h1 className="cart_agree_item_title">{t("Height")}</h1>
                <h2 className="cart_agree_item_desc">
                  {NumToFa(cartValues["WindowHeight"] + t("Measurements CM"))}
                </h2>
              </div>
            </span>
          </li>
        );
      }
    }
    // pageLanguage برای ترجمه لیبل‌ها و ارقام فارسی؛ cartValues با key در والد رفرش می‌شود
  }, [pageLanguage, modelId, location.pathname]);

  return (
    <div>
      <h1 className="cart_agree_item_title titleBasket">{t("MEASUREMENTS")}</h1>
      <ul className="measurements_container">{measurements}</ul>
    </div>
  );
}

export default GetMeasurementArrayPanel;
